import { Component, Input } from '@angular/core';
import { AbstractControl, ControlContainer, FormGroupDirective } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ErrorInputFieldComponent } from '@cargos/sprintpay-models';

@Component({
    selector: 'app-invalid-field',
    templateUrl: './invalid-field.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    imports: [MatFormFieldModule]
})
export class InvalidFieldComponent {
    public messageConfig: ErrorInputFieldComponent[];

    constructor(private parent: FormGroupDirective) {}

    @Input({ required: true }) field: string;
    @Input({ required: true })
    set messageList(messageList: ErrorInputFieldComponent[] | ErrorInputFieldComponent) {
        this.messageConfig = Array.isArray(messageList) ? messageList : [messageList];
    }

    get input(): AbstractControl | null {
        return this.parent.form?.get(this.field);
    }

    get errorVisible(): boolean {
        if (!this.input?.errors) {
            return false;
        }

        return this.input.touched || this.input.dirty;
    }
}
